module.exports = __webpack_public_path__ + "dc03759380afe40e9a58f80883effe28.MP3";